var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "info-view__wrapper" },
    [
      _c(
        "div",
        { class: { "info-view__hide": _vm.isHide } },
        [
          _c("breadcrumb", { attrs: { links: _vm.breadcrumbLinks } }),
          !_vm.isLoading
            ? _c(
                "div",
                [
                  _c(
                    "pui-grid-container",
                    { staticClass: "bg-light-red" },
                    [
                      _c(
                        "pui-grid-row",
                        { staticClass: "bg-light-green" },
                        [
                          _c(
                            "pui-grid-column",
                            {
                              staticClass: "bg-light-purple1",
                              attrs: {
                                cols: { s: 12, m: 12, l: 12, xl: 5, xxl: 5 },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "info-view__drilldown" },
                                [
                                  _c("EventInfo", {
                                    on: {
                                      splitEventPUT: _vm.handleSplitEventPUT,
                                      updateChart: _vm.handleUpdateChart,
                                      deleteBreadcrumb: _vm.deleteBreadcrumb,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "pui-grid-column",
                            {
                              staticClass: "bg-light-purple1",
                              attrs: {
                                cols: { s: 12, m: 12, l: 12, xl: 7, xxl: 7 },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "info-view__parallel" },
                                [
                                  _c("EventParallel", {
                                    attrs: {
                                      data: _vm.eventInfo,
                                      "split-events": _vm.splitEvents,
                                      "split-boolean": _vm.splitBoolean,
                                      "update-boolean": _vm.updateBoolean,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.isParentEvent && !_vm.isHide
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "info-view__history",
                                      staticStyle: { width: "100%" },
                                    },
                                    [
                                      _c("EventHistory", {
                                        attrs: {
                                          "history-data": _vm.eventHistoryData,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.isLoading || _vm.isHide
        ? _c("pui-loader-spinner", {
            attrs: { title: `${_vm.$t("eventSubmittingModal.text")}...` },
          })
        : _vm._e(),
      _c("ConfirmationModal", {
        ref: "ConfirmationModalRef",
        attrs: {
          "message-text": _vm.$t("navigation.unsavedChanges"),
          "cancel-label": _vm.$t("cancel"),
        },
        on: {
          "on-cancel": _vm.ConfirmationModalCancelled,
          "on-confirm": _vm.ConfirmationModalConfirmed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }